/*
 *
 *
 *
 *   Copyright (c) 2022. TinyMedic Pvt Ltd  - All Rights Reserved.
 *   This file is part of the API module  of the project: TinyMedic-Platform.
 *
 *
 *   Proprietary and confidential.
 *
 *   Unauthorized copying of this file, via any medium is strictly prohibited.
 *    Any resources of   TinyMedic-Platform can not be copied and/or distributed without the express permission of TinyMedic Pvt Ltd.
 *
 *
 *
 */

import React, { useEffect } from 'react';
import { Link, useNavigate, useParams } from 'react-router-dom';
import { Button, Col, Row } from 'reactstrap';
import { Translate, ValidatedField, ValidatedForm, isNumber, translate } from 'react-jhipster';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';

import { useAppDispatch, useAppSelector } from 'app/config/store';

import { getEntities as getSpecialityVitals } from 'app/entities/speciality-vitals/speciality-vitals.reducer';
import { getEntities as getGlucoUsers } from 'app/entities/gluco-user/gluco-user.reducer';
import { getEntities as getPrescriptions } from 'app/entities/prescription/prescription.reducer';
import { getEntities as getAppointments } from 'app/entities/appointments/appointments.reducer';
import { createEntity, getEntity, reset, updateEntity } from './prescription-spec-vital.reducer';

export const PrescriptionSpecVitalUpdate = () => {
  const dispatch = useAppDispatch();

  const navigate = useNavigate();

  const { id } = useParams<'id'>();
  const isNew = id === undefined;

  const specialityVitals = useAppSelector(state => state.specialityVitals.entities);
  const glucoUsers = useAppSelector(state => state.glucoUser.entities);
  const prescriptions = useAppSelector(state => state.prescription.entities);
  const appointments = useAppSelector(state => state.appointments.entities);
  const prescriptionSpecVitalEntity = useAppSelector(state => state.prescriptionSpecVital.entity);
  const loading = useAppSelector(state => state.prescriptionSpecVital.loading);
  const updating = useAppSelector(state => state.prescriptionSpecVital.updating);
  const updateSuccess = useAppSelector(state => state.prescriptionSpecVital.updateSuccess);

  const handleClose = () => {
    navigate(`/prescription-spec-vital${location.search}`);
  };

  useEffect(() => {
    if (isNew) {
      dispatch(reset());
    } else {
      dispatch(getEntity(id));
    }

    dispatch(getSpecialityVitals({}));
    dispatch(getGlucoUsers({}));
    dispatch(getPrescriptions({}));
    dispatch(getAppointments({}));
  }, []);

  useEffect(() => {
    if (updateSuccess) {
      handleClose();
    }
  }, [updateSuccess]);

  const saveEntity = values => {
    if (values.lastUpdated !== undefined && typeof values.lastUpdated !== 'number') {
      values.lastUpdated = Number(values.lastUpdated);
    }
    if (values.microSec !== undefined && typeof values.microSec !== 'number') {
      values.microSec = Number(values.microSec);
    }
    if (values.timestampEntry !== undefined && typeof values.timestampEntry !== 'number') {
      values.timestampEntry = Number(values.timestampEntry);
    }
    if (values.cursor !== undefined && typeof values.cursor !== 'number') {
      values.cursor = Number(values.cursor);
    }

    const entity = {
      ...prescriptionSpecVitalEntity,
      ...values,
      specVital: specialityVitals.find(it => it.id.toString() === values.specVital?.toString()),
      patient: glucoUsers.find(it => it.id.toString() === values.patient?.toString()),
      prescription: prescriptions.find(it => it.id.toString() === values.prescription?.toString()),
      appointment: appointments.find(it => it.id.toString() === values.appointment?.toString()),
    };

    if (isNew) {
      dispatch(createEntity(entity));
    } else {
      dispatch(updateEntity(entity));
    }
  };

  const defaultValues = () =>
    isNew
      ? {}
      : {
          ...prescriptionSpecVitalEntity,
          specVital: prescriptionSpecVitalEntity?.specVital?.id,
          patient: prescriptionSpecVitalEntity?.patient?.id,
          prescription: prescriptionSpecVitalEntity?.prescription?.id,
          appointment: prescriptionSpecVitalEntity?.appointment?.id,
        };

  return (
    <div>
      <Row className="justify-content-center">
        <Col md="8">
          <h2 id="tinyMedicRestApp.prescriptionSpecVital.home.createOrEditLabel" data-cy="PrescriptionSpecVitalCreateUpdateHeading">
            <Translate contentKey="tinyMedicRestApp.prescriptionSpecVital.home.createOrEditLabel">
              Create or edit a PrescriptionSpecVital
            </Translate>
          </h2>
        </Col>
      </Row>
      <Row className="justify-content-center">
        <Col md="8">
          {loading ? (
            <p>Loading...</p>
          ) : (
            <ValidatedForm defaultValues={defaultValues()} onSubmit={saveEntity}>
              {!isNew ? (
                <ValidatedField
                  name="id"
                  required
                  readOnly
                  id="prescription-spec-vital-id"
                  label={translate('tinyMedicRestApp.prescriptionSpecVital.id')}
                  validate={{ required: true }}
                />
              ) : null}
              <ValidatedField
                label={translate('tinyMedicRestApp.prescriptionSpecVital.active')}
                id="prescription-spec-vital-active"
                name="active"
                data-cy="active"
                check
                type="checkbox"
              />
              <ValidatedField
                label={translate('tinyMedicRestApp.prescriptionSpecVital.lastUpdated')}
                id="prescription-spec-vital-lastUpdated"
                name="lastUpdated"
                data-cy="lastUpdated"
                type="text"
              />
              <ValidatedField
                label={translate('tinyMedicRestApp.prescriptionSpecVital.microSec')}
                id="prescription-spec-vital-microSec"
                name="microSec"
                data-cy="microSec"
                type="text"
              />
              <ValidatedField
                label={translate('tinyMedicRestApp.prescriptionSpecVital.timestampEntry')}
                id="prescription-spec-vital-timestampEntry"
                name="timestampEntry"
                data-cy="timestampEntry"
                type="text"
              />
              <ValidatedField
                label={translate('tinyMedicRestApp.prescriptionSpecVital.cursor')}
                id="prescription-spec-vital-cursor"
                name="cursor"
                data-cy="cursor"
                type="text"
                validate={{
                  required: { value: true, message: translate('entity.validation.required') },
                  validate: v => isNumber(v) || translate('entity.validation.number'),
                }}
              />
              <ValidatedField
                label={translate('tinyMedicRestApp.prescriptionSpecVital.observation')}
                id="prescription-spec-vital-observation"
                name="observation"
                data-cy="observation"
                type="text"
                validate={{
                  maxLength: { value: 500, message: translate('entity.validation.maxlength', { max: 500 }) },
                }}
              />
              <ValidatedField
                label={translate('tinyMedicRestApp.prescriptionSpecVital.comments')}
                id="prescription-spec-vital-comments"
                name="comments"
                data-cy="comments"
                type="text"
                validate={{
                  maxLength: { value: 500, message: translate('entity.validation.maxlength', { max: 500 }) },
                }}
              />
              <ValidatedField
                id="prescription-spec-vital-specVital"
                name="specVital"
                data-cy="specVital"
                label={translate('tinyMedicRestApp.prescriptionSpecVital.specVital')}
                type="select"
              >
                <option value="" key="0" />
                {specialityVitals
                  ? specialityVitals.map(otherEntity => (
                      <option value={otherEntity.id} key={otherEntity.id}>
                        {otherEntity.id}
                      </option>
                    ))
                  : null}
              </ValidatedField>
              <ValidatedField
                id="prescription-spec-vital-patient"
                name="patient"
                data-cy="patient"
                label={translate('tinyMedicRestApp.prescriptionSpecVital.patient')}
                type="select"
              >
                <option value="" key="0" />
                {glucoUsers
                  ? glucoUsers.map(otherEntity => (
                      <option value={otherEntity.id} key={otherEntity.id}>
                        {otherEntity.id}
                      </option>
                    ))
                  : null}
              </ValidatedField>
              <ValidatedField
                id="prescription-spec-vital-prescription"
                name="prescription"
                data-cy="prescription"
                label={translate('tinyMedicRestApp.prescriptionSpecVital.prescription')}
                type="select"
              >
                <option value="" key="0" />
                {prescriptions
                  ? prescriptions.map(otherEntity => (
                      <option value={otherEntity.id} key={otherEntity.id}>
                        {otherEntity.id}
                      </option>
                    ))
                  : null}
              </ValidatedField>
              <ValidatedField
                id="prescription-spec-vital-appointment"
                name="appointment"
                data-cy="appointment"
                label={translate('tinyMedicRestApp.prescriptionSpecVital.appointment')}
                type="select"
              >
                <option value="" key="0" />
                {appointments
                  ? appointments.map(otherEntity => (
                      <option value={otherEntity.id} key={otherEntity.id}>
                        {otherEntity.id}
                      </option>
                    ))
                  : null}
              </ValidatedField>
              <Button tag={Link} id="cancel-save" data-cy="entityCreateCancelButton" to="/prescription-spec-vital" replace color="info">
                <FontAwesomeIcon icon="arrow-left" />
                &nbsp;
                <span className="d-none d-md-inline">
                  <Translate contentKey="entity.action.back">Back</Translate>
                </span>
              </Button>
              &nbsp;
              <Button color="primary" id="save-entity" data-cy="entityCreateSaveButton" type="submit" disabled={updating}>
                <FontAwesomeIcon icon="save" />
                &nbsp;
                <Translate contentKey="entity.action.save">Save</Translate>
              </Button>
            </ValidatedForm>
          )}
        </Col>
      </Row>
    </div>
  );
};

export default PrescriptionSpecVitalUpdate;
